export const isBinaryBody = (body: any): boolean =>
	body instanceof Blob ||
	body instanceof File ||
	body instanceof ArrayBuffer ||
	body instanceof Uint8Array;

export const toSearchParams = (data: Record<string, unknown>): string => {
	const params = new URLSearchParams();

	Object.entries(data).forEach(([key, value]) => {
		if (value !== undefined && value !== null) {
			params.append(key, String(value));
		}
	});

	return params.toString();
};

export const wsCloseCode = (event: number | CloseEvent): number =>
	typeof event === 'number' ? event : event.code;
